export default "__VITE_ASSET__TTSsGbpz__"